<p class="p-[34px] text-[24px] font-bold text-[#203D54]">payment works!</p>
